import "./BookingSuccess.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const DONE_SCREEN_URL = `${process.env.PUBLIC_URL}/booking-done.html`;

const BookingSuccess = () => {
  const navigate = useNavigate();

  const handleGoProfile = () => {
    navigate("/myProfile", { state: { openTab: "upcoming" }, replace: true });
  };

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handleBackButton = () => {
      navigate("/myProfile", { state: { openTab: "upcoming" }, replace: true });
    };

    window.addEventListener("popstate", handleBackButton);
    return () => window.removeEventListener("popstate", handleBackButton);
  }, [navigate]);

  return (
    <div className="booking-success-page">
      <iframe
        title="Booking complete"
        src={DONE_SCREEN_URL}
        className="booking-success-frame"
      />
      <button
        type="button"
        className="booking-success-profile-btn"
        onClick={handleGoProfile}
      >
        Go to Profile
      </button>
    </div>
  );
};

export default BookingSuccess;
